import script from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"

import "./PartnersSection.vue?vue&type=style&index=0&id=9a04d6a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a04d6a4"]])

export default __exports__